<mat-tab-group>
  @if (helper.tienePermiso('Administración - Ver inactividad usuarios')) {
    <mat-tab label="Inactividad">
      <ng-template matTabContent>
        <app-listado-inactividad-usuarios></app-listado-inactividad-usuarios>
      </ng-template>
    </mat-tab>
  }
  @if (helper.tienePermiso('Administración - Ver periodo actividad usuarios')) {
    <mat-tab label="Periodo de actividad">
      <ng-template matTabContent>
        <app-listado-periodo-actividad-usuarios></app-listado-periodo-actividad-usuarios>
      </ng-template>
    </mat-tab>
  }
</mat-tab-group>
